module.exports = __webpack_public_path__ + "img/wow33-static-png.2cad6ed9.png";